import { render, staticRenderFns } from "./FriendManagementGroupSearchResult.vue?vue&type=template&id=5cdbcf18&scoped=true"
import script from "./FriendManagementGroupSearchResult.vue?vue&type=script&lang=ts"
export * from "./FriendManagementGroupSearchResult.vue?vue&type=script&lang=ts"
import style0 from "./FriendManagementGroupSearchResult.vue?vue&type=style&index=0&id=5cdbcf18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdbcf18",
  null
  
)

export default component.exports